// extracted by mini-css-extract-plugin
module.exports = {"rippleContainer":"Ripple_rippleContainer__D70GE","ripple":"Ripple_ripple__rZtqm","ripple-animation":"Ripple_ripple-animation__wueVr"};